import { motion } from 'framer-motion'
import { FileCheck, Gift, RotateCcw, XCircle } from 'lucide-react'
import { Modal } from '@/components/ui/Modal'
import type { DealStage } from '@/types'

export function StageChoiceModal({
  open,
  onClose,
  onSelect,
}: {
  open: boolean
  onClose: () => void
  onSelect: (stage: DealStage) => void
}) {
  const choices: { stage: DealStage; title: string; description: string; icon: React.ElementType; color: string }[] = [
    {
      stage: 'gerar_contrato',
      title: 'Gerar Contrato',
      description: 'Cliente aceitou a proposta. Seguir para formalização do contrato.',
      icon: FileCheck,
      color: '#2563EB',
    },
    {
      stage: 'teste_gratis',
      title: '30 dias Grátis',
      description: 'Cliente vai testar por 30 dias. Um lembrete é criado para retomar a negociação.',
      icon: Gift,
      color: '#0EA5E9',
    },
    {
      stage: 'renegociacao',
      title: 'Renegociação',
      description: 'Cliente pediu ajustes. Voltar para renegociação dos termos.',
      icon: RotateCcw,
      color: '#E35933',
    },
    {
      stage: 'perdido',
      title: 'Perdido',
      description: 'Infelizmente o negócio não foi fechado.',
      icon: XCircle,
      color: '#EF4444',
    },
  ]

  return (
    <Modal open={open} onClose={onClose} title="Atualizar Status" size="sm">
      <div className="space-y-3">
        <p className="text-xs text-text-label">
          A proposta foi enviada. Escolha o próximo passo:
        </p>

        <div className="grid grid-cols-1 gap-2">
          {choices.map((ch) => (
            <motion.button
              key={ch.stage}
              whileHover={{ scale: 1.01 }}
              whileTap={{ scale: 0.99 }}
              onClick={() => onSelect(ch.stage)}
              className="flex items-start gap-3 p-3 rounded-lg bg-white/[0.03] border border-white/[0.06] hover:border-accent/30 transition-all text-left"
            >
              <div
                className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 mt-0.5"
                style={{ backgroundColor: `${ch.color}20` }}
              >
                <ch.icon size={16} style={{ color: ch.color }} />
              </div>
              <div>
                <p className="text-sm font-medium text-text-primary">{ch.title}</p>
                <p className="text-xs text-text-label mt-0.5">{ch.description}</p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </Modal>
  )
}
